module.exports = __webpack_public_path__ + "img/info-h.3ea7d9cb.jpg";